import { useLocation, useNavigate } from 'react-router-dom';
import { LanguagePreference } from '../../interface';
import { getLanguageFromPath, localizePath } from '../../utils';
import './index.css';

export const LanguageSwitcher = () => {
  const { pathname, search, hash, state } = useLocation();
  const navigate = useNavigate();
  const currentLanguage = getLanguageFromPath(pathname);

  const toggleLanguage = () => {
    const newLang =
      currentLanguage === LanguagePreference.LATVIAN
        ? LanguagePreference.ENGLISH
        : LanguagePreference.LATVIAN;
    navigate(`${localizePath(pathname, newLang)}${search}${hash}`, { state });
  };

  return (
    <button className="language-switcher" onClick={toggleLanguage}>
      {currentLanguage === LanguagePreference.LATVIAN ? 'EN' : 'LV'}
    </button>
  );
};
